<template>
  <div>
    <div class="title2" v-if="corporateFeatureInfoLabels.length>0"><h2><img src="@/assets/img/common/icon-nav7.svg" alt="" width="22" height="22">会社の特徴</h2></div>

    <div class="inner">
      <ul class="audit-label-list">
        <li v-for="label in corporateFeatureInfoLabels" :key="label">{{label}}</li>
      </ul>
    </div>
<!--    <div class="inner t-center" v-else>
      <p class="l-text">まだ会社の特徴が設定されていません。<br>
        法人情報 ＞ 基本情報で会社の情報を入力された内容がここに表示されます。</p>
        <div class="btn-basic is-inlne is-primary mt-30"><a @click="goCorp">法人情報を入力</a></div>
    </div>-->
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    corpId: {},
  },
  data() {
    return {
      corporateFeatureInfoLabels:[],
      dataIncomplete: false,
    }
  },
  created: function() {
    this.getCorporateFeatureInfoLabels(this.corpId);
  },
  methods: {
    async getCorporateFeatureInfoLabels(corpId) {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateFeatureInfoLabels', {
        corpId: corpId,
      });
      if (res) {
        this.dataIncomplete = res.data.dataIncomplete;
        this.corporateFeatureInfoLabels = res.data.corporateFeatureInfoLabels;
      }
    },
    goCorp() {
      this.$router.push({ name: 'corporate-edit', query: { corpId: this.corpId } });
    },
  }
}
</script>

<style scoped>
.chart-area {
  border: 2px solid rgba(220, 220, 220, 0.5);
  border-radius: 10px;
  padding: 10px;
  background-color: rgba(248, 248, 255, 0.5);
}
</style>